<script setup lang="ts">

import { onMounted } from "vue";
import { useViewModelInstance } from "@app/MyGarage";
import { useBackButton } from "@app/Components/Utilities";

import CarbucksRewards from "./Features/CarbucksRewards.vue";
import RoadsideAssistanceFeature from "./Features/RoadsideAssistanceFeature.vue";

const model = await useViewModelInstance();

onMounted( () =>
{
    useBackButton();
} );

</script>

<template>

    <div class="px-4 2xl:px-6 h-full overflow-y-auto pt-4 2xl:pt-6 pb-12 flex flex-col gap-4 2xl:gap-6">
        
        <CarbucksRewards v-model="model.carePlan" />

        <RoadsideAssistanceFeature 
            v-if="model.carePlan.roadsideAssistance.isEnabled"
            v-model="model.carePlan.roadsideAssistance" 
            :key="model.$updateKey" 
        />
        
    </div>

</template>